import get from 'lodash/get';

export default question => get(question, 'settings.name'); // displayableName could be used instead



// WEBPACK FOOTER //
// ./src/components/Survey/helpers/getQuestionType.js